import _ from 'lodash';
import React from 'react';
import {connect} from 'react-redux';
import {Field, reduxForm, isSubmitting} from 'redux-form';

import {EmailField, PasswordField, TokenField} from 'components/Fields';
import FormField from 'components/FormField';
import Button from 'components/Button';
import ErrorBlock from 'components/ErrorBlock';

import {
  changeUserPasswordAndLogin,
  selectInvitationUserErrors
} from 'ducks/auth';

import './styles.css';

const formSubmit = (values, dispatch) => {
  const {email, token, password} = values;

  dispatch(changeUserPasswordAndLogin({email, key: token, password}));
};

class AcceptInvitationForm extends React.Component<any> {
  render() {
    const {submitting, handleSubmit, errors, email} = this.props;
    const submitDisabled = submitting || !_.isNil(errors) || _.isEmpty(email);
    return (
      <form className="AcceptInvitationForm" onSubmit={handleSubmit}>
        {errors && <ErrorBlock>{errors}</ErrorBlock>}
        <FormField>
          <Field
            component={EmailField}
            placeholder="Email"
            name="email"
            disabled={true}
          />
        </FormField>
        <FormField>
          <Field
            component={TokenField}
            placeholder="Token"
            name="token"
            disabled={true}
          />
        </FormField>
        <FormField>
          <Field
            component={PasswordField}
            placeholder="Password"
            name="password"
            disabled={submitDisabled}
          />
        </FormField>
        <FormField>
          <Button disabled={submitDisabled}>Login →</Button>
        </FormField>
      </form>
    );
  }
}

const mapStateToProps = (state, props) => {
  const {email, token} = props;

  return {
    errors: selectInvitationUserErrors(state),
    submitting: isSubmitting('acceptInvitation')(state),
    initialValues: {
      email,
      token
    }
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'acceptInvitation',
    onSubmit: formSubmit,
    enableReinitialize: true,
    keepDirtyOnReinitialize: true
  })(AcceptInvitationForm)
);
